import React, { useEffect, FC } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { IconTypes } from 'components/Icons';
import { MetadataTabs } from 'containers/ActiveCloudResource/types';
import { DataTableComponent } from 'containers/Visibility/Data/Components/DataTable/DataTableComponent';
import { useDataTableColumns } from 'containers/Visibility/Data/Components/hooks/useDataTableColumns';
import { selectDataDashboard } from 'containers/Visibility/Data/selectors';
import { actions } from 'containers/Visibility/Data/slice';
import { useSearchParams } from 'hooks/useSearchParams';

export const DataTable: FC = () => {
  const { selectedTab } = useSelector(selectDataDashboard);
  const { handleRowClick } = useDataTableColumns(MetadataTabs.Data);
  const params = useSearchParams<{
    account_id: string;
    uuid: string;
    resource_type: string;
    resource_id: string;
  }>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !!params.uuid &&
      !!params.resource_type &&
      !!params.account_id &&
      !!params.resource_id &&
      selectedTab === IconTypes.DataSources
    )
      handleRowClick({
        service: params.resource_type,
        source_UUID: params.uuid,
        account_id: params.account_id,
        resource_id: params.resource_id,
      });
  }, [
    params.uuid,
    params.resource_type,
    handleRowClick,
    selectedTab,
    params.account_id,
    params.resource_id,
  ]);

  useEffect(() => {
    dispatch(actions.getDataClassifiers({}));
  }, [dispatch]);

  return <DataTableComponent />;
};
